import { AudioBlockView } from "@src/lms/jelly/extensions/blocks/audio/AudioBlockView";
import { TimelineBlock } from "@src/lms/jelly/extensions/blocks/timeline/TimelineBlock";
import { TableBlockView } from "@src/lms/jelly/extensions/blocks/table/TableBlockView";
import { Panner3BlockView } from "@src/lms/jelly/extensions/blocks/panner3/PannerBlockView";
import { IDSliderBlockView } from "@src/lms/jelly/extensions/blocks/itdSlider/ITDILDSliderBlockView";
import { AudioSliderBlockView } from "@src/lms/jelly/extensions/blocks/audioSlider/AudioSliderBlockView";
import { InfoBoxBlock } from "@src/lms/jelly/extensions/blocks/infobox/InfoBoxBlock";

export const audio = AudioBlockView;
export const timeline = TimelineBlock;
export const spatialTable = TableBlockView;
export const panner3 = Panner3BlockView;
export const itdSlider = IDSliderBlockView;
export const audioSlider = AudioSliderBlockView;
export const infoBox = InfoBoxBlock;
